// Original, illustrative screen colours. This fixed reference is derived from
// the season label; the twelve analyser suggestions remain the personal result.
// Display colours are not calibrated fabric or cosmetic matches.
const C = {
  ivory: ['Soft ivory', '#EEE2CA'], cream: ['Warm cream', '#F1DDB4'], white: ['Clear white', '#F6F6F2'],
  oyster: ['Oyster', '#DED5CC'], sand: ['Sand', '#D9C5A3'], beige: ['Warm beige', '#CDB394'],
  camel: ['Camel', '#B88961'], taupe: ['Taupe', '#A99B91'], mushroom: ['Mushroom', '#9B8B82'],
  stone: ['Cool stone', '#B4B8B7'], grey: ['Soft grey', '#A5A8B0'], charcoal: ['Charcoal', '#51535B'],
  brown: ['Chocolate brown', '#604238'], espresso: ['Espresso', '#3D302D'], black: ['Black', '#242428'],
  navy: ['Navy', '#293F5B'], softnavy: ['Soft navy', '#44576B'], ink: ['Ink blue', '#263C57'],
  blush: ['Blush pink', '#DBA6A8'], rose: ['Dusty rose', '#BE858E'], coral: ['Soft coral', '#DC8C80'],
  peach: ['Peach', '#E8A27F'], apricot: ['Apricot', '#E5AA79'], salmon: ['Salmon', '#D78578'],
  terracotta: ['Terracotta', '#B56955'], rust: ['Rust', '#A6583E'], brick: ['Brick red', '#A04E47'],
  oxblood: ['Muted oxblood', '#713C43'], burgundy: ['Burgundy', '#6F304A'], wine: ['Wine red', '#7E3D59'],
  cranberry: ['Cranberry', '#AE3F58'], trueRed: ['True red', '#C73041'], tomato: ['Tomato red', '#C74C3D'],
  poppy: ['Poppy red', '#E65243'], fuchsia: ['Fuchsia', '#C52D81'], hotpink: ['Hot pink', '#E43E8E'],
  raspberry: ['Raspberry', '#B54678'], watermelon: ['Watermelon', '#DD6680'],
  butter: ['Butter yellow', '#EED68B'], gold: ['Golden yellow', '#D5A742'], mustard: ['Mustard', '#B59642'],
  lemon: ['Lemon yellow', '#E9D45A'], orange: ['Warm orange', '#D87543'],
  sage: ['Sage green', '#9AA889'], olive: ['Olive', '#7B8456'], moss: ['Moss green', '#667C59'],
  forest: ['Forest green', '#386551'], emerald: ['Emerald', '#257A65'], kelly: ['Kelly green', '#288F66'],
  mint: ['Mint', '#A4D5B8'], lime: ['Lime', '#A8C556'], jade: ['Jade', '#4C9A80'],
  teal: ['Teal', '#327B80'], petrol: ['Deep petrol', '#275A63'], turquoise: ['Turquoise', '#49AEB3'],
  aqua: ['Aqua', '#8BCBCB'], powderBlue: ['Powder blue', '#A6C0D0'], denim: ['Soft denim', '#6887A0'],
  sky: ['Sky blue', '#78B6DA'], cobalt: ['Cobalt blue', '#315CB6'], royal: ['Royal blue', '#3559A8'],
  icyBlue: ['Icy blue', '#D2E5EE'], lavender: ['Lavender', '#B8A4C9'], lilac: ['Lilac', '#C8B3D6'],
  mauve: ['Mauve', '#A789AD'], plum: ['Plum', '#684B73'], violet: ['Violet', '#7753AA'],
  aubergine: ['Aubergine', '#513A5B'], periwinkle: ['Periwinkle', '#9EA8D6'],
  neonPink: ['Neon pink', '#F3279D'], neonLime: ['Neon lime', '#B8F421'],
};

const PROFILES = {
  'Light Spring': {
    best: 'ivory cream sand beige camel blush coral peach apricot salmon watermelon poppy butter lemon mint lime jade turquoise aqua sky powderBlue lavender periwinkle teal',
    caution: 'black charcoal espresso burgundy aubergine neonPink',
  },
  'True Spring': {
    best: 'ivory cream beige camel brown coral peach apricot salmon tomato poppy orange butter gold lemon lime kelly jade turquoise aqua sky teal royal violet',
    caution: 'black charcoal grey mushroom burgundy mauve',
  },
  'Bright Spring': {
    best: 'ivory white camel brown navy coral peach watermelon poppy trueRed tomato hotpink lemon gold lime kelly emerald jade turquoise aqua sky cobalt royal violet',
    caution: 'mushroom taupe grey rose sage olive',
  },
  'Light Summer': {
    best: 'oyster white stone grey taupe softnavy blush rose watermelon raspberry powderBlue sky icyBlue aqua denim periwinkle lavender lilac mauve mint sage teal plum',
    caution: 'black espresso rust orange mustard neonLime',
  },
  'True Summer': {
    best: 'oyster white stone grey charcoal softnavy navy blush rose raspberry cranberry wine powderBlue denim sky icyBlue aqua teal mint sage lavender lilac mauve periwinkle plum',
    caution: 'orange rust mustard camel tomato neonLime',
  },
  'Soft Summer': {
    best: 'oyster stone grey taupe mushroom softnavy navy blush rose wine oxblood raspberry mauve lavender lilac plum periwinkle powderBlue denim teal sage moss mint aqua',
    caution: 'orange tomato poppy lemon neonPink neonLime',
  },
  'Soft Autumn': {
    best: 'ivory cream sand beige camel taupe mushroom brown blush rose coral peach salmon terracotta brick oxblood butter mustard sage olive moss forest teal petrol denim lavender',
    caution: 'white black cobalt hotpink lemon neonLime',
  },
  'True Autumn': {
    best: 'ivory cream sand beige camel brown espresso peach apricot salmon terracotta rust brick oxblood tomato orange gold mustard olive moss forest jade teal petrol turquoise',
    caution: 'white black icyBlue hotpink fuchsia lilac',
  },
  'Deep Autumn': {
    best: 'ivory cream camel brown espresso charcoal navy peach salmon terracotta rust brick oxblood burgundy wine tomato gold mustard olive moss forest emerald jade teal petrol aubergine',
    caution: 'white icyBlue powderBlue lilac neonPink neonLime',
  },
  'Deep Winter': {
    best: 'white black charcoal grey stone espresso navy ink blush raspberry cranberry burgundy wine oxblood trueRed fuchsia hotpink emerald forest petrol teal cobalt royal violet plum aubergine icyBlue',
    caution: 'camel beige peach apricot mustard olive',
  },
  'True Winter': {
    best: 'white black charcoal grey stone navy ink blush raspberry cranberry burgundy trueRed fuchsia hotpink emerald kelly teal turquoise cobalt royal icyBlue powderBlue periwinkle violet plum aubergine',
    caution: 'camel beige peach apricot orange mustard',
  },
  'Bright Winter': {
    best: 'white black charcoal navy ink blush watermelon cranberry trueRed poppy fuchsia hotpink neonPink lemon lime kelly emerald jade turquoise aqua cobalt royal icyBlue periwinkle violet plum',
    caution: 'camel taupe mushroom sage olive rust',
  },
};

export function seasonPalette(season) {
  const profile = PROFILES[season];
  if (!profile) return null;
  const convert = (keys) => keys.split(' ').map((key) => ({ key, name: C[key][0], hex: C[key][1] }));
  return { best: convert(profile.best), caution: convert(profile.caution) };
}

export const SEASON_NAMES = Object.keys(PROFILES);

const SEASON_MEANINGS = {
  'Light Spring': 'Light Spring is a name for light, fresh colours with a little warmth, like peach, apricot and aqua.',
  'True Spring': 'True Spring is a name for warm, lively colours, like coral, golden yellow and jade.',
  'Bright Spring': 'Bright Spring is a name for clear, vivid colours with warmth, like poppy red, turquoise and lime.',
  'Light Summer': 'Light Summer is a name for light, cool-leaning colours, like powder blue, soft pink and lavender.',
  'True Summer': 'True Summer is a name for cool, softened colours, like dusty rose, soft denim and lilac.',
  'Soft Summer': 'Soft Summer is a name for muted, cool-leaning colours, like mauve, soft navy and sage green.',
  'Soft Autumn': 'Soft Autumn is a name for gently warm, muted colours, like camel, terracotta and sage green.',
  'True Autumn': 'True Autumn is a name for warm, earthy colours, like rust, olive and golden yellow.',
  'Deep Autumn': 'Deep Autumn is a name for rich, gently warm colours, like espresso, rust and forest green.',
  'Deep Winter': 'Deep Winter is a name for deep, cool-leaning colours with strong contrast, like navy, burgundy and emerald.',
  'True Winter': 'True Winter is a name for cool, clear colours with crisp contrast, like cobalt blue, true red and black.',
  'Bright Winter': 'Bright Winter is a name for vivid, cool-leaning colours, like fuchsia, cobalt blue and clear white.',
};

export function seasonMeaning(season) {
  return SEASON_MEANINGS[season] || null;
}
